import { useQuery } from "@tanstack/react-query";

import { useCompanyApi } from "./common";

export function useSearchCompany(searchTerm: string) {
  const companyApi = useCompanyApi();
  return useQuery({
    queryKey: ["searchCompany", searchTerm],
    queryFn: () => companyApi.searchCompanies({ searchTerm }),
    enabled: searchTerm.length > 2,
  });
}
